import {Component, OnInit} from '@angular/core';
import {TitleService} from "./services/title.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'app';
  
  constructor(private _titleService: TitleService) {
  }
  
  ngOnInit() {
    this._titleService.InitTitle();
  }
}
